<template>
    <div id="ManageUser" class="starter-template">
        <b-container>
            <br>
            <h4 class="text-center">{{this.$t('PROF_CH')}}</h4>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-row>
                    <b-col cols="5">
                        <br><br>
                        <h4>{{this.$t('LOGIN1')}}</h4>
                        <b-form-group>
                            <b-form-input
                                    v-model.trim="$v.form.userName.$model"
                                    :state="validateState('userName')"
                                    aria-described-by="input-1"
                                    disabled
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-1"
                            ><h5>{{this.$t('R_NAME')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <h4>Email</h4>
                        <b-form-group>
                            <b-form-input
                                    v-model.trim="$v.form.userEmail.$model"
                                    :state="validateState('userEmail')"
                                    aria-described-by="i-email"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="i-email"
                            ><h5>{{this.$t('R_EMAIL')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <h4>{{this.$t('PWD_NEW')}}</h4>
                        <b-form-group>
                            <b-form-input
                                    type="password"
                                    v-model.trim="$v.form.pwd.$model"
                                    :state="validateState('pwd')"
                                    aria-described-by="input-2"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-2"
                            ><h5>{{this.$t('R_PWD')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <h4>{{this.$t('PWD2')}}</h4>
                        <b-form-group>
                            <b-form-input
                                    type="password"
                                    v-model.trim="$v.form.pwd2.$model"
                                    :state="validateState('pwd2')"
                                    aria-described-by="input-3"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-3"
                            ><h5>{{this.$t('R_PWD2')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2"></b-col>
                    <b-col cols="5">
                        <br><br>
                        <h4>{{this.$t('FST_NAME')}}</h4>
                        <b-form-group>
                            <b-form-input
                                v-model.trim="$v.form.userFirstName.$model"
                                :state="validateState('userFirstName')"
                                aria-described-by="input-4"
                                :placeholder="form.userFirstName"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-4"
                            ><h5>{{this.$t('R_NAME')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <h4>{{this.$t('LST_NAME')}}</h4>
                        <b-form-group>
                            <b-form-input
                                    v-model.trim="$v.form.userLastName.$model"
                                    :state="validateState('userLastName')"
                                    aria-described-by="input-5"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                    id="input-5"
                            ><h5>{{this.$t('R_NAME')}}</h5>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-row align-v="center">
                        <b-col>
                        <div @click="chooseImage">
                            <b-avatar :src="avatarUrl" size="10em"></b-avatar>
                            <input
                                class="file-input"
                                ref="fileInput"
                                type="file"
                                accept="image/*"
                                @input="onSelectFile"
                            >
                        </div>
                        </b-col>
                            <b-col>
                                <h4>{{$t('AVATAR')}}</h4>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-form-row>

                <center>
                    <h4>{{$t('I_AM')}}:</h4>

                    <b-form-radio-group id="radio-group" v-model="form.userType" name="radio-sub-component">
                        <b-form-radio value="t"><h4>{{$t('TOURIST')}}</h4></b-form-radio>
                        <b-form-radio value="g"><h4>{{$t('GUIDE')}}</h4></b-form-radio>
                        <b-form-radio value="c"><h4>{{$t('TRAVEL_CR')}}</h4></b-form-radio>
                    </b-form-radio-group>
                    <br>

                    <b-row v-if="form.userType === 'g' || form.userType === 'c'">
                        <b-col cols="5" v-if="form.userType === 'c'">
                            <h4>{{$t('COM_NAME')}}<span class="redC">*</span></h4>
                            <b-form-group>
                                <b-form-input
                                        v-model.trim="$v.form.companyName.$model"
                                        :state="validateState('companyName')"
                                        aria-described-by="input-1"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                        id="i-company"
                                ><h5>{{$t('R_ITEM_NAME')}}</h5>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2"></b-col>
                        <b-col cols="5">
                            <h4>{{$t('URL_HOME')}} ({{$t('OPTION')}})</h4>
                            <b-form-group>
                                <b-form-input
                                        v-model.trim="$v.form.homeUrl.$model"
                                        :state="validateState('homeUrl')"
                                        aria-described-by="i-url"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                        id="i-email"
                                ><h5>{{$t('R_URL')}}</h5>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>

                </center>



            </b-form>
        </b-container>

        <b-container fluid class="footer text-center">
            <b-button class="m-1" @click="save()">{{$t('SAVE')}}</b-button>
            <b-button class="m-1" @click="$router.go(-1)">{{$t('CANCEL')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
            v-on:closeHelp="showHelp=false"
            v-bind:helpName="helpName"
            v-if="showHelp"
        />

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BForm, BFormRow, BFormGroup, BFormRadio, BFormRadioGroup, BFormInput, BButton, BAvatar, BFormInvalidFeedback } from 'bootstrap-vue';
import { validationMixin } from "vuelidate";
import { helpers, required, requiredIf, minLength, maxLength, sameAs, minValue, email, url } from 'vuelidate/lib/validators';
import Help from "./Help.vue";
import {Cnst} from '@/plugins/Cnst.js';

const userNameR = helpers.regex('userNameR',/^(?!.*?[-\s]{2})[a-zA-Z.\-а-яА-ЯёЁ\s]+$/);
const itemNameR = helpers.regex('itemNameR',/^(?!\.)(?!.*?[-\s]{2})(?!.*?[']{3})[a-zA-Z0-9.,()\-'а-яА-ЯёЁ\s]+$/);

export default {
  name: 'ManageUser',
  components: {
    Help,
    BContainer, BRow, BCol, BForm, BFormRow, BFormGroup, BFormRadio, BFormRadioGroup, BFormInput, BButton, BAvatar, BFormInvalidFeedback
  },
  mixins: [validationMixin],
  data: function() {
    return {
      form: {
        userName: '',
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        pwd: '',
        pwd2: '',
        userType: 't',
        companyName: '',
        homeUrl: ''
      },
      avatarUrl: '',
      files: null,
      helpName: 'HelpManageUser',
      showHelp: false,

      url: ''
    }
  },
  mounted() {
    this.userName = this.$store.state.curUserName;
    this.getUser();
  },
  methods: {
    validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
    },
    async getUser() {
        try {
            let response = await this.$http.get('getUserR', {
                params: {
                    userName: this.userName
                }
            });
            let user = response.data;
            this.form.userName = user.userName;
            this.form.userEmail = user.userEmail;
            this.form.userFirstName = user.userFirstName;
            this.form.userLastName = user.userLastName;
            this.form.pwd = '';
            this.form.pwd2 = '';
            this.avatarUrl = user.avatarUrl+"?key="+Math.random();
            if(user.userType!='t' && user.userType!='c' && user.userType!='g') this.form.userType = 't';
            else this.form.userType = user.userType;
            this.form.companyName = user.companyName;
            this.form.homeUrl = user.homeUrl;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageUser: getUser() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    save() {
        this.$v.form.$touch();
        if(this.$v.form.$anyError) return;
        this.uploadAvatar();
    },
    chooseImage () {
        this.$refs.fileInput.click();
    },
    onSelectFile () {
        const input = this.$refs.fileInput;
        this.files = input.files;
        if (this.files && this.files[0]) {
            const reader = new FileReader;
            reader.onload = e => {
                this.avatarUrl = e.target.result;
            }
            reader.readAsDataURL(this.files[0]);
            this.$emit('input', this.files[0]);
        }
    },
    async uploadAvatar() {
        let data = new FormData();
        if(!this.files) this.saveRest();
        else {
            if( this.files[0] == undefined) {
                this.$serveErr('ManageUser: uploadAvatar() this.files[0] = undefined');
                return;
            }
            if(this.files[0].size/1000 > Cnst.MAX_AVAT_SIZE) {
                this.$showErr(this.$t('R_AVAT'));
                return;
            }
            data.append('file', this.files[0]);
            try {
                await this.$http.post('upload', data,
                    {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }
                );
                this.saveRest();
            } catch(error) {
                if(typeof error.response === 'undefined') this.$serveErr('ManageUser: uploadAvatar() '+error.message);
                else this.$showErr(error.response.data, error.response.status);
                return;
            }
        }
    },
    async saveRest() {
        try {
            const response = await this.$http.post('/editUser', {
                userName: this.form.userName,
                userEmail: this.form.userEmail,
                userFirstName: this.form.userFirstName,
                userLastName: this.form.userLastName,
                userPwd: this.form.pwd,
                userType: this.form.userType,
                companyName: this.form.companyName,
                homeUrl: this.form.homeUrl
            });
            this.$showMsg(response.data);
            //window.location = '/';
            this.$store.commit('incAvatarKey');
            this.$router.push({ path: '/' });
         } catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManageUser: save() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  validations: {
    form: {
        userName: {
            required,
            userNameR,
            minLength: minLength(2),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        userFirstName: {
            required,
            userNameR,
            minLength: minLength(2),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        userLastName: {
            required,
            userNameR,
            minLength: minLength(2),
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        userEmail: {
            required,
            email,
            maxLength: maxLength(Cnst.MAX_NAME_SIZE)
        },
        pwd: {
            maxLength: maxLength(Cnst.MAX_PWD_SIZE)
        },
        pwd2: {
            maxLength: maxLength(Cnst.MAX_PWD_SIZE),
            sameAs: sameAs(function () { return this.form.pwd })
        },
        companyName: {
          required: requiredIf(function () { return this.form.userType == 'c' } ),
          itemNameR,
          minLength: minLength(2),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
        },
        homeUrl: {
          url,
          minLength: minLength(4),
          maxLength: maxLength(Cnst.MAX_ITEM_NAME_SIZE)
        },
        maxSize: {
          minValue: minValue(0)
        },
    },
  },

}

</script>

<style scoped>
>>> h5{
    color: red;
    font-size: 1.2em;
}
.redC{
    color: red;
}
.pl2em{
    padding-left: 2em;
}

.file-input {
  display: none;
}

</style>

